import React from 'react';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { FORM_DEFAULTS } from 'talent_matching/filter_form_defaults';
import { useFiltersApplied } from 'talent_matching/hooks/use_people';
import { withLocalePrefix } from 'shared/utils/translation';
import NoResultsOverlay from 'talent_matching/components/shared/no_results_overlay';

const t = withLocalePrefix('talent_matching.table.no_results');

const AppReviewNoResultsOverlay = () => {
  const filtersApplied = useFiltersApplied();
  const { reset } = useFormContext();

  const handleClearAll = () => {
    reset(FORM_DEFAULTS);
  };

  return (
    <NoResultsOverlay
      hasAnyFilters={filtersApplied}
      onClearAll={handleClearAll}
      filteredHeader={t('header')}
      filteredBody={t('body')}
      clearButtonLabel={t('button')}
      emptyHeader={t('empty')}
    />
  );
};

export default AppReviewNoResultsOverlay;
